"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function ImageIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M19.151,3.981H4.849A2.853,2.853,0,0,0,2,6.831V17.169a2.853,2.853,0,0,0,2.85,2.85h14.3A2.853,2.853,0,0,0,22,17.169V6.831A2.853,2.853,0,0,0,19.151,3.981Zm-14.3,1.7h14.3A1.153,1.153,0,0,1,20.3,6.831V17.169a1.087,1.087,0,0,1-.045.22l-4.989-4.314a.639.639,0,0,0-.934,0l-1.907,2.066a.638.638,0,0,1-.954-.019L8.3,11.405a.638.638,0,0,0-.956-.017L3.7,15.376V6.831A1.153,1.153,0,0,1,4.849,5.68Z" }),
        react_1.default.createElement("path", { d: "M16.853,10.561a1.428,1.428,0,1,0-1.427-1.428A1.428,1.428,0,0,0,16.853,10.561Z" })));
}
exports.default = ImageIcon;
